const MENU_CONFIG = {
    CRM_REQUEST_SUPPORT: 'crm_request_support',
};
export default MENU_CONFIG;
